import articleSelectorController from './articleSelectorController';

const sectionBlocks = [...document.querySelectorAll('.articles-container .section')];
const body = document.body;
// const data = require('./data/data');
// const sections = data.sections;

const blocksController = (function() {
    function hide(section) {
        [...sectionBlocks[section].querySelectorAll('.article')].forEach(article => {
            article.classList.remove('show');
        });
    }
    function show(section, block) {
        [...sectionBlocks[section].querySelectorAll('.article')].forEach((article, index) => {
            if (index === block) {
                article.classList.add('show');
                body.dataset.article = index;
                articleSelectorController.switchArticle(index);
            } else {
                article.classList.remove('show');
            }
        });
    }
    return {
        hide: hide,
        show: show
    };
})();
export default blocksController;
